import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Pagination } from "react-bootstrap";

export const Pager = ({
  currentPage,
  allPage,
  topPager = false,
  bottomPager = true,
  children,
  handleChangePage,
}) => {
  const PagerComponent = ({ className }) => (
    <div className={className}>
      <Pagination style={{ justifyContent: "flex-end" }}>
        <Pagination.First
          disabled={allPage === 0 || currentPage === 0}
          onClick={() => handleChangePage(0)}
        />
        <Pagination.Prev
          disabled={allPage === 0 || currentPage === 0}
          onClick={() => handleChangePage(currentPage - 1)}
        />
        <Pagination.Item active>
          {allPage} / {currentPage + 1}
        </Pagination.Item>
        <Pagination.Next
          disabled={allPage === 0 || currentPage + 1 === allPage}
          onClick={() => handleChangePage(currentPage + 1)}
        />
        <Pagination.Last
          disabled={allPage === 0 || currentPage + 1 === allPage}
          onClick={() => handleChangePage(allPage - 1)}
        />
      </Pagination>
    </div>
  );

  return (
    <Row className="mt-4 mb-4">
      <Col>
        {topPager ? <PagerComponent className="mb-2" /> : null}
        <>{children}</>
        {bottomPager ? <PagerComponent className="mt-2" /> : null}
      </Col>
    </Row>
  );
};

Pager.propTypes = {
  currentPage: PropTypes.number.isRequired,
  allPage: PropTypes.number.isRequired,
  topPager: PropTypes.bool,
  bottomPager: PropTypes.bool,
  children: PropTypes.element.isRequired,
  handleChangePage: PropTypes.func.isRequired,
};
